import { setupCamera } from '@pimred/camera-poster';
import '@pimred/camera-poster/src/dist/style.css';

/**
 * Sets up a camera preview and allows the user to take a photo to be uploaded to a specified URL.
 *
 * @param {HTMLElement} spawnerButton - The HTML element that will spawn the camera module when clicked.
 * @param {string} postUrl - The URL to which the photo will be uploaded.
 * @param {function} callbackFunction - The function to be called after the photo is uploaded. Takes a single parameter, which is the data returned from the server.
 * @returns {void}
 */
Drupal.behaviors.isbnUpload = {
  attach() {
    const buttons = document.querySelectorAll('a[href="#isbn-upload"]');
    buttons.forEach((button) => {
      if (!button.classList.contains('isbn-upload--processed')) {
        setupCamera(button, 'https://ocr-middleware.pimred.cloud/ocr', (data) => {
          if (data.isbnList) {
            console.log('Detected with love: ' + data.isbnList.join(','));
          }
          data.isbnList.reverse()
          document.getElementsByTagName('body')[0].dispatchEvent(new CustomEvent('add-to-main-cart', {detail: {'items': data.isbnList, tracking: 'Foto-Scan', type: 'c_scan' }}));
        })
      }
      button.classList.add('isbn-upload--processed');
    });
  },
};
